import Page from "../Page";
import Component from "~/components/Component";
import CambioPasswordComponent from "~/components/CambioPasswordComponent";
import { initShowHidePassword } from "~/components/ShowHidePassword";
import DocumentoModal from "~/components/modals/DocumentoModal";

import UI from "~/ui";
import * as _ from "~/utils";
import * as validation from "~/utils/validation";
import * as activeTab from "~/utils/attivaTabDaHash";
import {extractBirth, FiscalCodeOptions, validateCodiceFiscale} from "~/utils/codicefiscale";

import * as Auth from "~/auth";
import {domSelectors} from "~/globals";
//import {initDatepickers} from "~/datepicker";
import * as autocomplete from "~/autocomplete";
import {format, parse} from "date-fns";
import {getApi, handleError} from "~/auth";
import {getFormData, gotoLogin} from "~/utils";
import {result} from "lodash";
import $ from "jquery";
import { ConsensiForm } from "~/components/ConsensiForm";
import { DatiAnagrafici} from "~/components/DatiAnagrafici";

class ProfiloError extends Component {
    constructor() {
        super("#errorMessage");
    }

    public showError(message: string) {
        $(this.domElement).html(message);
        $(this.domElement).removeClass("d-none");
        $(this.domElement).toggleClass("alert-success", false);
        $(this.domElement).toggleClass("alert-danger", true);
    }

    public showInfo(message: string) {
        $(this.domElement).html(message);
        $(this.domElement).removeClass("d-none");
        $(this.domElement).toggleClass("alert-danger", false);
        $(this.domElement).toggleClass("alert-success", true);
    }

    public hideError() {
        $(this.domElement).html("");
        $(this.domElement).addClass("d-none");
    }
}

class DocumentiTab {
}



class Profilo extends Page {
    private _tabProfilo: DatiAnagrafici = new DatiAnagrafici({ strictValidation: false });
    private _tabConsensi: ConsensiForm = new ConsensiForm("frmPrivacy");
    private _documentoModal: DocumentoModal = new DocumentoModal("#modalCaricaDocumentoUtente", "frmDocumentoUtente");

    private get tabTitleElement(): HTMLElement {
        return document.querySelector("h1 span.profilo-tab-title") as HTMLElement;
    }

    private set tabTitle(title: string) {
        this.tabTitleElement.innerText = title;
    }

    private tabElements() {
        return document.querySelectorAll("#profiloTab button.userButton");
    }

    public async pageStart(): Promise<void> {
        const that = this;
        UI.bindWaiting();
        this.spinner.stop();
        await this._documentoModal.activate();

        // Inizializza la funzionalità di mostra/nascondi password
        initShowHidePassword();
     
        // Attiva il tab iniziale
        this.tabElements().forEach((tab) => {
            tab.addEventListener('shown.bs.tab', async function (e) {
                console.log("Tab attivato:", e.target);
                const form = tab.attributes.getNamedItem("rif")?.value;

                switch (form) {
                    case "frmProfilo":
                        await that.activateDatiPersonaliTab();
                        break;
                    case "frmDocumenti":
                        await that.activateDocumentiTab();
                        break;
                    case "frmCambioPassword":
                        await that.activateCambioPasswordTab();
                        break;
                    case "frmPrivacy":
                        await that.activatePrivacyTab();
                        break;
                    default:
                        console.log("Tab non riconosciuto");
                }
            })
        })
        // Aggiungi qui la chiamata alla funzione attivaTabDaHash
        activeTab.attivaTabDaHash("#profiloTab", ".profilo-tab-title", "datipersonali");
        
        //initDatepickers(); 

        //se login esterno, disabilitare il cambio password


        //setup tab profilo

        //setup tab privacy

        //setup tab notifiche
        //setup tab preferiti
        //setup tab documenti utente

        //setup validatore cambio pw

        return Promise.resolve();
    }

    private async activateDatiPersonaliTab(): Promise<void> {
        this.tabTitle = "Dati Personali";
        let tab = this._tabProfilo;
        await tab.activate();
        // console.log("Tab Dati Personali attivato");
    }

    private async activateDocumentiTab(): Promise<void> {
        this.tabTitle = "Documenti";
        // console.log("Tab Documenti attivato");
    }

    private async activateCambioPasswordTab(): Promise<void> {
        this.tabTitle = "Cambio Password";
        // console.log("Tab CambioPassword attivato");

        // Inizializza il componente di cambio password
        const cambioPasswordComponent = new CambioPasswordComponent("#frmCambioPassword");

        // Opzionale: imposta una callback per quando il cambio password ha successo
        cambioPasswordComponent.setOnSuccessCallback(() => {
            // Ad esempio, mostra un messaggio o torna al tab profilo
            $("button.userButton[rif='frmProfilo']").tab('show');
        });

        await cambioPasswordComponent.activate();
    }

    private async activatePrivacyTab(): Promise<void> {
        this.tabTitle = "Consensi Privacy";
        await this._tabConsensi.activate();
        console.log("Tab Privacy attivato");
    }


    constructor() {
        super("profilo", "Profilo utente");
    }

    private disableCambioPasswordLoginExt() {
        //TODO: disabilitare il cambio password per gli utenti autenticati con login esterno (nascondere la sezione)
        $("button.userButton[rif='frmCambioPassword']").click(function (e) {
            e.preventDefault();
            alert("Password protetta da Identità Digitale");
            $(this).css("pointer-events", "none");
            return false;
        });

    }
}

const $container = function (field: JQuery<HTMLElement>): JQuery<HTMLElement> {
    let $field = $(field[0]);
    let $container = $field.closest(".form-floating").parent();
    return $container;
}


export default Profilo;